import { Box, Typography } from '@mui/material'
import Link from 'next/link'
import { PartnerPageData } from 'types/types'

export function FooterGambleAwareLogo({ page }: { page: PartnerPageData }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '200px' }}>
      <img
        width={150}
        height={50}
        src="/GambleAware.png"
        alt="Logo"
        style={{ width: 'auto', height: 'auto', maxWidth: '150px', maxHeight: '50px' }}
      />
      <Typography fontSize={12} color={page.footer_text_color}>
        Star Sports All rights reserved. Star Racing Ltd (licence number{' '}
        <Link
          style={{ textDecoration: 'underline' }}
          prefetch={false}
          href="https://www.gamblingcommission.gov.uk/public-register/business/detail/9177"
          target="_blank"
        >
          009177
        </Link>
        ) is licensed and regulated by the Gambling Commission.
      </Typography>
    </Box>
  )
}
